import { render, staticRenderFns } from "./BillingNetworkTag.vue?vue&type=template&id=20c83a67&scoped=true&"
import script from "./BillingNetworkTag.vue?vue&type=script&lang=ts&"
export * from "./BillingNetworkTag.vue?vue&type=script&lang=ts&"
import style0 from "./BillingNetworkTag.vue?vue&type=style&index=0&id=20c83a67&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c83a67",
  null
  
)

export default component.exports